export default "__VITE_ASSET__8033a93a__"